module.exports = "/images/london-29.jpg";